import { TranslatedText } from "@/components/common/text";
import { RateValueText } from "./RateValueText";

export const RateBoundsLabels = ({ leftLabel, rightLabel, minValue, maxValue, emptyDash = false }) => (
    <div className="flex flex-row items-end justify-between gap-4">
        <div className="flex flex-col items-start">
            <TranslatedText className="text-xs/[19px] text-cm-p-text-secondary">{leftLabel}</TranslatedText>
            <RateValueText num={minValue} round emptyDash={emptyDash} className="text-base/[25px] text-cm-p-text-primary font-medium" />
        </div>
        <div className="flex flex-col items-end">
            <TranslatedText className="text-xs/[19px] text-cm-p-text-secondary">{rightLabel}</TranslatedText>
            <RateValueText num={maxValue} round emptyDash={emptyDash} className="text-base/[25px] text-cm-p-text-primary font-medium" />
        </div>
    </div>
);
